import React, { useState } from "react";
import { DropdownButton, DropdownContainer, DropdownContent } from "./styles";
import { RiArrowDownSLine } from "react-icons/ri";

const Dropdown = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <DropdownContainer>
      <DropdownButton onClick={() => setIsOpen(!isOpen)}>
        Suporte
        <RiArrowDownSLine />
      </DropdownButton>
      <DropdownContent isOpen={isOpen}>
        <a href="#documentacao">Documentação</a>
        <a href="#sandbox">Sandbox</a>
        <a href="#fale-conosco">Fale conosco</a>
      </DropdownContent>
    </DropdownContainer>
  );
};

export default Dropdown;
